export enum PLAYER {
  FIRST = 'Player 1',
  SECOND = 'Player 2',
  THIRD = 'Player 3',
  FOURTH = 'Player 4',
}